<div class="position-relative w-500">
  <div>
    <div class="d-flex justify-content-center info-icon mt-3"><mat-icon class="material-symbols-outlined info-col"> chat_info </mat-icon></div>
    <div>
      <div mat-dialog-content class="d-flex justify-content-center flex-column color-black text-center">
        <div class="color-black font-20">Möchten Sie die <br> Ansicht wechseln?</div>
      </div>
      <div mat-dialog-actions class="justify-content-around flex-column">
        <button mat-button [mat-dialog-close]="'yes'" class="yes-button">Ja, Ansicht wechseln</button>
        <button mat-button [mat-dialog-close]="'no'" class="no-button">Abbrechen</button>
      </div>
    </div>
  </div>
  <div class="text-center color-black close-btn" [mat-dialog-close]="'no'"><mat-icon class="material-symbols-outlined">close</mat-icon></div>
</div>

